var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// includes
import HttpClient from '@/includes/httpClient';
import { RequestHeaderKeys } from '@local/typedefs/dist/common/headers';
import { AdvertiserMetrics, } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
// helpers
import { getPartnerServiceBasePath } from '@/helpers/endpoints';
import { readFromLocalStorage } from '@/helpers/storage';
// constants
import { PartnerServiceEndpoints } from '@/constants/endpoints';
import { localStorageKeys } from '@/constants/storage';
import dayjs from 'dayjs';
const DEFAULT_METRICS = [
    AdvertiserMetrics.METRIC_TYPE_GMV,
    AdvertiserMetrics.METRIC_TYPE_ROI,
    AdvertiserMetrics.METRIC_TYPE_IMPRESSION_COUNT,
    AdvertiserMetrics.METRIC_TYPE_ADD_TO_CART,
    AdvertiserMetrics.METRIC_TYPE_BUDGET_BURNT,
];
const getMetricsDefaultInterval = () => {
    return {
        startTime: dayjs().subtract(90, 'day').toISOString(),
        endTime: dayjs().subtract(1, 'day').toISOString(),
    };
};
export const getMetricsApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ accountId, campaignIds, interval = getMetricsDefaultInterval(), dimensions = [], metrics = DEFAULT_METRICS, }) {
    try {
        const url = `${getPartnerServiceBasePath()}${PartnerServiceEndpoints.METRICS}`;
        const accessToken = yield readFromLocalStorage(localStorageKeys.ACCESS_TOKEN);
        const headers = {
            Authorization: `Bearer ${accessToken}`,
            [RequestHeaderKeys.X_CLIENT_ACCOUNT_ID]: accountId !== null && accountId !== void 0 ? accountId : '',
        };
        const payload = {
            dimensions,
            metrics,
            filters: [
                {
                    type: 'FILTER_CAMPAIGN',
                    value: campaignIds,
                },
            ],
            interval,
        };
        const response = yield HttpClient.post(url, payload, headers);
        return response.data;
    }
    catch (err) {
        if (__DEV__) {
            console.log(err);
        }
    }
});
